/**
 * ItemGo Service Vehicle Transport — Pricing Engine
 *
 * Base price includes first 20 miles. Extra miles charged per mile.
 * All values in pence (GBP). VAT on (servicePrice + serviceFee).
 * Everything configurable from Firestore pluginConfigs/{serviceId}.
 */
export const DEFAULT_VEHICLETRANSPORT_PRICING_CONFIG = {
    serviceFee: 599, // £5.99
    vatRate: 0.20, // 20%
    basePrice: 15000, // £150.00 — includes first 20 miles
    pricePerMile: 200, // £2.00 per mile beyond included
    includedMiles: 20,
    enclosedMultiplier: 1.5,
    multiVehicleDiscount: 0.1, // 10%
    minDistance: 1,
    conditionReportFee: 2500, // £25.00
};
export function calculateVehicleTransportPricing(input) {
    const config = input.config;
    const distance = Math.max(input.distanceMiles, config.minDistance);
    const vehicleCount = Math.max(input.vehicleCount || 1, 1);
    const basePrice = config.basePrice;
    const includedMiles = config.includedMiles ?? 20;
    const extraMiles = Math.max(0, distance - includedMiles);
    const distanceCharge = Math.round(extraMiles * config.pricePerMile);
    let subtotal = basePrice + distanceCharge;
    const enclosedSurcharge = input.isEnclosed
        ? Math.round(subtotal * (config.enclosedMultiplier - 1))
        : 0;
    const conditionReportFee = input.needsConditionReport
        ? config.conditionReportFee
        : 0;
    subtotal += enclosedSurcharge + conditionReportFee;
    // Apply multi-vehicle discount
    const multiVehicleDiscount = vehicleCount > 1
        ? Math.round(subtotal * config.multiVehicleDiscount)
        : 0;
    const servicePrice = subtotal - multiVehicleDiscount;
    const serviceFee = config.serviceFee ?? 599;
    const vatRate = config.vatRate ?? 0.20;
    const vatAmount = Math.round((servicePrice + serviceFee) * vatRate);
    const customerTotal = servicePrice + serviceFee + vatAmount;
    return {
        basePrice,
        includedMiles,
        extraMiles,
        distanceCharge,
        enclosedSurcharge,
        conditionReportFee,
        multiVehicleDiscount,
        servicePrice,
        serviceFee,
        vatAmount,
        customerTotal,
        formatted: {
            basePrice: formatPence(basePrice),
            distanceCharge: formatPence(distanceCharge),
            enclosedSurcharge: formatPence(enclosedSurcharge),
            conditionReportFee: formatPence(conditionReportFee),
            multiVehicleDiscount: formatPence(multiVehicleDiscount),
            servicePrice: formatPence(servicePrice),
            serviceFee: formatPence(serviceFee),
            vatAmount: formatPence(vatAmount),
            customerTotal: formatPence(customerTotal),
        },
    };
}
export function formatPence(pence) {
    return `£${(pence / 100).toFixed(2)}`;
}
//# sourceMappingURL=pricing.js.map